import { Component, EventEmitter, OnInit, Input, Output } from '@angular/core';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import * as _ from "lodash";

//constants
import { Constants }         from '../../constants/Constants';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

@Component({
  selector: 'my-employees-autocomplete',
  templateUrl: './EmployeesAutoComplete.component.html'
})
export class EmployeesAutoCompleteComponent implements OnInit {

    filteredEmployees: any[];
    selectedEmployeeNumbers: string[] = [];
    employees: any[] = [];
    employee: any;
    employeesModel: any;
    
    userInfo: ent.UserInfo;
    
    @Input() public placeholder: string;
    @Input() public multiple: boolean;
    @Input() public disabled: boolean;
    @Output() onSelectedEmployeesChanged = new EventEmitter<string[]>();
    
    constructor(private authenticationService: serv.AuthenticationService, private employeeService: serv.EmployeeService) 
    { 
    }

    ngOnInit(): void {
        this.userInfo = this.authenticationService.getUserInfo();
        
    }

    filterEmployees(event: any, take: number): void {
        
        
        
        var filter: filters.EmployeeFilter = {EmployeeNameOrPersonnelNumberLike: event.query, Take: take};

        this.employeeService.getEmployees(filter).subscribe(x=>{
            this.filteredEmployees = []
            for (var employee of x)
            {
                this.filteredEmployees.push({name: employee.FullNameWithPersonnelNumber, ID: employee.ID});
            }
    
        });
        
    }


    onEmployeeSelected(selectedItem: any): void {
        this.selectedEmployeeNumbers.push(selectedItem.ID);
        this.onSelectedEmployeesChanged.emit(this.selectedEmployeeNumbers);
    }

    onEmployeeUnselected(selectedItem: any): void {
        
        _.remove(this.selectedEmployeeNumbers, x=>x==selectedItem.ID);
        this.onSelectedEmployeesChanged.emit(this.selectedEmployeeNumbers);
    }

    onClearClick(event: any){
        
        this.employees = [];
        this.employee = new ent.Employee();
        if (this.multiple){
            this.employeesModel = this.employees;
        }
        else{
            this.employeesModel = this.employee;
        }
        this.selectedEmployeeNumbers = [];
        this.onSelectedEmployeesChanged.emit(this.selectedEmployeeNumbers);
    }

}